import MainLayout from '@/layouts/MainLayout.vue';
import { requestHttp } from '@/services/HttpRequest';
import { inject } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'main',
        component: MainLayout,
        children: [
            {
                path: '/',
                name: 'home',
                component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
            },
            {
                path: '/parameters',
                name: 'parameters',
                component: () => import(/* webpackChunkName: "about" */ '../views/Parameter/ParameterView.vue')
            },
            {
                path: '/users',
                name: 'users',
                component: () => import(/* webpackChunkName: "about" */ '../views/User/UserView.vue')
            },
            {
                path: '/user',
                name: 'user',
                component: () => import(/* webpackChunkName: "about" */ '../views/User/ConsultView.vue')
            },
            {
                path: '/consult-register',
                name: 'consult-register',
                component: () => import(/* webpackChunkName: "about" */ '../views/Register/RegisterConsultView.vue')
            },
            {
                path: '/consult-stores',
                name: 'consult-stores',
                component: () => import(/* webpackChunkName: "about" */ '../views/Store/StoreView.vue')
            },
            {
                path: '/consult-votes',
                name: 'consult-votes ',
                component: () => import(/* webpackChunkName: "about" */ '../views/Votes/ConsultVotesView.vue')
            },
            {
                path: '/consult-votes-user',
                name: 'consult-votes-user',
                component: () => import(/* webpackChunkName: "about" */ '../views/Votes/UserVoteView.vue')
            },
            {
                path: '/sending-guides',
                name: 'sending-guides',
                component: () => import(/* webpackChunkName: "about" */ '../views/SendingGuides/SendingGuidesView.vue')
            },
            {
                path: '/file-charge',
                name: 'file-charge',
                component: () => import(/* webpackChunkName: "about" */ '../views/FileCharge/FileChargeView.vue')
            },
            {
                path: '/consult-prize',
                name: 'consult-prize',
                component: () => import(/* webpackChunkName: "about" */ '../views/ConsultPrizes/ConsultPrizesView.vue')
            },
            // router/index.js
            {
                path: "/heatmap",
                name: "heatmap",
                component: () => import(/* webpackChunkName: "about" */ '../views/Summary/HeatMapView.vue')
            },
            {
                path: '/tyc',
                name: 'tyc',
                component: () => import(/* webpackChunkName: "about" */ '../views/ManageTyC/ManageTyCView.vue')
            },
            {
                path: '/summary',
                name: 'summary',
                component: () => import(/* webpackChunkName: "about" */ '../views/Summary/SummaryView.vue')
            },
            {
                path: '/mass-notifications',
                name: 'mass-notifications   ',
                component: () => import(/* webpackChunkName: "about" */ '../views/MassNotification/MassNotificationView.vue')
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Login/LoginView.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notFount',
        component: () => import(/* webpackChunkName: "about" */ '../views/NotFound/NotFoundView.vue')
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from, next) => {
    const rootScope = inject('rootScope');

    try {
        if (to.name) {
            rootScope.loading = true;
            const response = await requestHttp({
                endpoint: 'auth/authStatus',
                body: {
                    route: to.name
                }
            });

            rootScope.loading = false;
            const data = response.data;

            if (data.estado === 400) {
                rootScope.logged = false;
                rootScope.name = '';
                rootScope.user = 0;
                if (to.name !== 'login' && to.name !== 'register') {
                    next({ name: 'login' });
                } else next();
            } else if (data.estado === 200) {
                localStorage.setItem('lastPath', to.path);
                const datosSession = data.data;
                rootScope.logged = datosSession.logueado;
                rootScope.name = datosSession.nombre;
                rootScope.user = datosSession.usuario;

                rootScope.permissions = { ...datosSession.permissions };

                // if (to.name !== 'password-change' && datosSession.restablecer_clave === 0) {
                //   next({name: 'password-change'});
                // }

                if (to.name === 'login' || to.name === 'register') {
                    next({ name: 'home' });
                } else {
                    next();
                }
            } else {
                rootScope.logged = false;
                next({ name: 'login' });
            }
        } else {
            next();
        }
    } catch (error) {
        rootScope.logged = false;
        rootScope.loading = false;
        next({ name: 'login' });
    }
});
export default router;
